/**
 * Stable.ts
 * @author Diao Zheng
 * @file Stable functions
 */
/**
 * A not exported symbol to declare this function as "Stable".
 * This is intentionally not exported.
 */
const STABLE = Symbol();
export function declareAsStable(f) {
    return f;
}
export function get(obj, key) {
    return declareAsStable(obj[key]);
}
